/* ============
 * All Product Types
 * ============
 *
 * All product types.
 */

import Vue from 'vue';
import store from '../../store';
import materialTypeTransformer from '../../transformers/materialType';

const success = ({ data }, resolve) => {
  const materialTypes = materialTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllMaterialTypes', materialTypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display product types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('production/material_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/materialType/all.js